import { EditFilled } from "@ant-design/icons";
import {
  Button,
  Col,
  Form,
  Input,
  InputNumber,
  message,
  Modal,
  Row,
  Space,
} from "antd";
import { useEffect, useState } from "react";
import { apiRequest } from "../../../api";
import apiPaths from "../../../api/paths";
import { useHasEditPermission } from "../../../common/hooks";

function DefaultValues() {
  const [data, setData] = useState({});
  const [updatedData, setUpdatedData] = useState(null);
  const allowEdit = useHasEditPermission();

  const getDefaultValues = async () => {
    let res = await apiRequest({
      path: apiPaths.constants + "/default_values",
    });
    if (!res.error) {
      setData(res.value || {});
    }
  };

  useEffect(() => {
    getDefaultValues();
  }, []);

  const handleUpdate = async (values) => {
    let res = await apiRequest({
      path: apiPaths.constants + "/default_values",
      method: "PUT",
      data: {
        value: values,
      },
    });

    if (res.error) {
      message.error(res.error_description);
      return;
    }
    setData({ ...values });
    setUpdatedData(null);
  };

  return (
    <div style={{ width: 300, padding: 20 }}>
      <div
        style={{
          display: "flex",
          marginBottom: 10,
          justifyContent: "space-between",
        }}
      >
        <div style={{ fontSize: 20 }}>Default Values</div>
        {allowEdit ? (
          <Button
            type="link"
            onClick={() => {
              setUpdatedData(data);
            }}
          >
            <EditFilled />
          </Button>
        ) : null}
      </div>
      <div style={{ border: "1px solid #b7b7b750" }}>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b750",
          }}
        >
          <Col span={12} style={{ fontWeight: "bold", padding: 5 }}>
            {"Key"}
          </Col>
          <Col
            span={12}
            style={{
              fontWeight: "bold",
              borderLeft: "1px solid #b7b7b730",
              padding: 5,
            }}
          >
            {"Value"}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b730",
          }}
          key={"s"}
        >
          <Col span={12} style={{ padding: 5 }}>
            {"Min Recharge Amount"}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {data.minimum_recharge_amount}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b730",
          }}
          key={"idx"}
        >
          <Col span={12} style={{ padding: 5 }}>
            {"Min Wallet Balance"}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {data.minimum_wallet_amount}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b730",
          }}
          key={3}
        >
          <Col span={12} style={{ padding: 5 }}>
            {"SOS Number"}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {data.sos}
          </Col>
        </Row>
        <Row
          style={{
            padding: 5,
            borderBottom: "1px solid #b7b7b730",
          }}
          key={3}
        >
          <Col span={12} style={{ padding: 5 }}>
            {"Ride Alt Time (min)"}
          </Col>
          <Col span={12} style={{ padding: 5 }}>
            {data.ride_alt_time}
          </Col>
        </Row>
      </div>

      {updatedData ? (
        <Modal
          title={"Update Values"}
          centered
          width={500}
          visible={true}
          onCancel={() => {
            setUpdatedData(null);
          }}
          footer={null}
        >
          <Form layout="vertical" initialValues={data} onFinish={handleUpdate}>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="minimum_recharge_amount"
                  label="Min Recharge Amount"
                  rules={[{ required: true, message: "Please input amount" }]}
                >
                  <InputNumber style={{ width: "100%" }} placeholder="amount" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="minimum_wallet_amount"
                  label="Min Wallet Balance"
                  rules={[{ required: true, message: "Please input amount" }]}
                >
                  <InputNumber style={{ width: "100%" }} placeholder="amount" />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={24}>
              <Col span={12}>
                <Form.Item
                  name="sos"
                  label="SOS Number"
                  rules={[{ required: true, message: "Please input number" }]}
                >
                  <Input style={{ width: "100%" }} placeholder="phone number" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="ride_alt_time"
                  label="Ride Alt Time (min)"
                  rules={[{ required: true, message: "Please input time" }]}
                >
                  <InputNumber style={{ width: "100%" }} placeholder="min" />
                </Form.Item>
              </Col>
            </Row>
            <Space style={{ display: "flex", justifyContent: "flex-end" }}>
              <Button
                onClick={() => {
                  setUpdatedData(null);
                }}
              >
                Cancel
              </Button>
              <Button type="primary" htmlType="submit">
                {"Save"}
              </Button>
            </Space>
          </Form>
        </Modal>
      ) : null}
    </div>
  );
}

export default DefaultValues;
